import { render } from "./OtpPinForm.vue?vue&type=template&id=da4238d4&scoped=true"
import script from "./OtpPinForm.vue?vue&type=script&lang=js"
export * from "./OtpPinForm.vue?vue&type=script&lang=js"

import "./OtpPinForm.vue?vue&type=style&index=0&id=da4238d4&lang=css"
import "./OtpPinForm.vue?vue&type=style&index=1&id=da4238d4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da4238d4"]])

export default __exports__